import { render, staticRenderFns } from "./backend.vue?vue&type=template&id=b8a6522a&scoped=true"
import script from "./backend.vue?vue&type=script&lang=js"
export * from "./backend.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b8a6522a",
  null
  
)

export default component.exports